import { Component, OnInit, forwardRef, Input, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import assessmentTypesJSON from 'src/assets/json/assessment-types.json';
import { AssessmentTypeDetails} from '../../interfaces/assessment-type-details';
import { productCodeTypes } from '../../index';
import { AppInitialProduct } from 'src/app/features';
import { Environment, IEnvironment } from 'src/app/shared/classes/environment';
import { ProductName } from '../../classes/productName.class';
import { GtmService } from 'src/app/core/services/gtm/gtm.service';

// This component can be used as a form control, within a reactive form.
// https://javascript-conference.com/blog/angular-reactive-forms-building-custom-form-controls/

const CUSTOM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AssessmentTypesComponent),
  multi: true
};

@Component({
  selector: 'app-assessment-types',
  templateUrl: './assessment-types.component.html',
  styleUrls: ['./assessment-types.component.scss'],
  providers: [CUSTOM_VALUE_ACCESSOR]
})
export class AssessmentTypesComponent implements OnInit, OnChanges {
  // TODO we want to be able to select an Assured equivalent of a product bundle, if available.
  @Input() appcode: string;
  @Input() refcode: string;
  @Input() bundleHasRefCode: boolean;
  @Input() bundle: string;
  selectedCode: string;
  selectedApplicationType: AssessmentTypeDetails;

  private assessmentTypes: AssessmentTypeDetails[] = [];
  private disabled: boolean;
  private onChange: Function;
  private onTouched: Function;
  private config: IEnvironment;

  constructor(private readonly gtmService: GtmService) {
    this.onChange = (_: any) => {};
    this.onTouched = () => {};
    this.disabled = false;
    this.selectedApplicationType = null;
  }

  getAssessmentTypes(): AssessmentTypeDetails[] {
    return this.assessmentTypes;
  }

  writeValue(obj: string): void {
    setTimeout(() => {
      this.selectedCode = obj;
      if (this.assessmentTypes.length > 1) this.selectedApplicationType = this.assessmentTypes.find(row => row.code === obj);
      else this.selectedApplicationType = this.assessmentTypes[0];
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  async ngOnInit() {
    const env = new Environment();
    this.config = await env.getConfig();
    this.presets();
    this.selectedCode = AppInitialProduct.AssessmentTypeCode;
    this.selectedApplicationType = null;
  }

  ngOnChanges() {
    this.presets();
    this.selectedApplicationType = this.assessmentTypes.find(row => row.code === this.selectedCode);
    this.onChange(this.selectedCode);
    this.onTouched();
  }

  trackByFn(index: number, item: AssessmentTypeDetails) {
    return index;
  }

  /**
   * Set the selected product bundle.
   */
  selectType(assessmentType: AssessmentTypeDetails): void {
    this.selectedCode = assessmentType.code;
    this.selectedApplicationType = assessmentType;
    this.onChange(this.selectedCode);
    this.onTouched();

    this.gtmService.pushTag({
      id: this.config.googleAnalytics.googleTagManagerId,
      event: 'select_assessmentType',
      assessmentType: assessmentType.name
    });
  }

  /**
   * Returns TRUE if the specified bundle is selected.
   */
  isSelected(assessmentType: AssessmentTypeDetails): boolean {
    return this.selectedCode === assessmentType.code;
  }

  private presets() {
    this.filterByAppCode();
    if(!this.selectedCode || !this.assessmentTypes.find(x => x.code === this.selectedCode)) {
      this.selectedCode = this.assessmentTypes[0].code;
    }
  }

  private filterByAppCode() {
    var typesToInclude = assessmentTypesJSON.filter(x => x.feesCode !== null);

    if (this.bundle && this.bundle.includes(ProductName.level4)) {
      this.assessmentTypes = typesToInclude.filter(type => type.code !== productCodeTypes.DTS);
    } else if (this.appcode && this.appcode === productCodeTypes.CARE) {
      this.assessmentTypes = typesToInclude.filter(type => type.code === productCodeTypes.FULLAPPLICATION);
    } else {
      this.assessmentTypes = typesToInclude;
    }
  }
}
